import "./App.css";
import SliderData from "./SliderData";

function App() {
  return (
    <div className="App">
      <SliderData />
    </div>
  );
}

export default App;
